import { PaymentMethod } from "../../shared/constant";
import globalUtils from "../../utils/globalUtils";

export const isAnyFilterExists = (details: any) => {
  if (
    details.invoice_filter_used.label ||
    details.invoice_filter_used.artist ||
    details.invoice_filter_used.lyricist ||
    details.invoice_filter_used.composer ||
    details.invoice_filter_used.track ||
    details.invoice_filter_used.platform ||
    details.invoice_filter_used.distributor
  )
    return true;
  return false;
};

const isAnyBankDetailsExists = (details: any) => {
  if (
    details.client_bank_details.account_name ||
    details.client_bank_details.account_no ||
    details.client_bank_details.bank ||
    details.client_bank_details.branch ||
    details.client_bank_details.routing_no ||
    details.client_bank_details.phone
  )
    return true;
  return false;
};

interface TableViewProps {
  c1: string | number;
  c2?: string | number;
  c3?: string | number;
  c4?: string | number;
  twClass?: string;
  header?: Boolean;
}

export const FilterView = ({ name, filterOption }: any) => {
  return (
    filterOption && (
      <div className="flex gap-3">
        <div className="font-semibold">{name}:</div>
        <div>{filterOption}</div>
      </div>
    )
  );
};

export function RecordView({ title, text }: { title: string; text: string }) {
  return (
    <div className="flex gap-3 mb-0.5">
      <div className="text-secondary">{title}</div>
      <div>{text}</div>
    </div>
  );
}

export function TableView({ c1, c2, c3, c4, twClass, header }: TableViewProps) {
  return (
    <div className={`grid grid-cols-12 mx-4 ${twClass}`}>
      <div className={`col-span-6 ${header && "font-semibold"}`}>{c1}</div>
      <div className="col-span-6 grid grid-cols-3">
        <div className={` ${header && "font-semibold"}`}>{c2}</div>
        <div className={` ${header && "font-semibold"}`}>{c3}</div>
        <div className={` ${header && "font-semibold"} place-self-end`}>
          {c4}
        </div>
      </div>
    </div>
  );
}

export function AggregateView({
  title,
  value,
  printView = false,
}: {
  title: string;
  value: string;
  printView?: Boolean;
}) {
  return (
    <div
      className={`grid grid-cols-12 ${
        printView ? "mt-[5px]" : " mt-[13px]"
      } mx-4`}
    >
      <div className="col-span-6" />
      <div
        className={`col-span-6 grid grid-cols-3 flash-border ${
          printView ? "pb-[5px]" : "pb-[13px]"
        }`}
      >
        <div />
        <div className={`${title !== "TAX" && "font-semibold"}`}>{title}</div>
        <div className={`${title !== "TAX" && "font-semibold"} place-self-end`}>
          {value}
        </div>
      </div>
    </div>
  );
}

export function FiltersUsed({ details }: any) {
  return (
    <div>
      {!isAnyFilterExists(details) ? (
        "None"
      ) : (
        <>
          <FilterView
            name="Label"
            filterOption={details.invoice_filter_used.label}
          />
          <FilterView
            name="Artist"
            filterOption={details.invoice_filter_used.artist}
          />
          <FilterView
            name="Lyricist"
            filterOption={details.invoice_filter_used.lyricist}
          />
          <FilterView
            name="Composer"
            filterOption={details.invoice_filter_used.composer}
          />
          <FilterView
            name="Track"
            filterOption={details.invoice_filter_used.track}
          />
          <FilterView
            name="Platform"
            filterOption={details.invoice_filter_used.platform}
          />
          <FilterView
            name="Distributor"
            filterOption={details.invoice_filter_used.distributor}
          />
        </>
      )}
    </div>
  );
}

export function PaymentMethodView({ details, printView = false }: any) {
  return (
    <>
      <div className="flex gap-3 my-2.5">
        <div className="font-semibold">Payment Method: </div>
        <span>
          {globalUtils.snakeCaseToCapitalize(details.display_payment_method)}
        </span>
      </div>
      {details.display_payment_method === PaymentMethod.CASH || (
        <div>
          <div className="mb-2 font-semibold">Deposit To:</div>
          <div className="grid grid-cols-10 gap-16">
            <div
              className={`default-border p-4 ${
                printView ? "col-span-6" : "bg-lotion col-span-4"
              }`}
            >
              {!isAnyBankDetailsExists(details) && (
                <div className="text-secondary">No Data</div>
              )}
              {details.client_bank_details.account_name && (
                <RecordView
                  title="Account Name:"
                  text={details.client_bank_details.account_name}
                />
              )}
              {details.client_bank_details.account_no && (
                <RecordView
                  title="Account No:"
                  text={details.client_bank_details.account_no}
                />
              )}
              {details.client_bank_details.bank && (
                <RecordView
                  title="Bank:"
                  text={details.client_bank_details.bank}
                />
              )}
              {details.client_bank_details.branch && (
                <RecordView
                  title="Branch:"
                  text={details.client_bank_details.branch}
                />
              )}
              {details.client_bank_details.routing_no && (
                <RecordView
                  title="Routing Number:"
                  text={details.client_bank_details.routing_no}
                />
              )}
              {details.client_bank_details.phone && (
                <RecordView
                  title="Phone No:"
                  text={details.client_bank_details.phone}
                />
              )}
            </div>
            {/* {details.is_clap_service_charge_show && (
                <div className="default-border col-span-4 h-16 self-end">
                  <div className="px-4 h-full flex items-center font-semibold">
                    {details.service_charge}% Service charge deducted
                    from total payment as per agreement
                  </div>
                </div>
              )} */}
          </div>
        </div>
      )}
    </>
  );
}
